import { css } from '@emotion/react';

const locationHeaderStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    }),
    closeIcon: css({
        cursor: 'pointer',
    }),
    head: css({
        display: 'flex',
        height: '64px',
        padding: '15px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '600px',
        margin: '0 auto',
        boxSizing: 'border-box',
    }),
    headTitle: css({
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        cursor: 'copy',
        whiteSpace: 'nowrap',
        width: '100%',
        overflow: 'hidden',
        maxWidth: '270px',
        ['@media (min-width: 600px)']: {
            maxWidth: '300px',
        },
        '& span': {
            display: 'inline-block',
            animation: 'marquee 10s linear infinite',
        },
        '@keyframes marquee': {
            from: {
                transform: 'translateX(300px)',
            },
            to: {
                transform: 'translateX(-300px)',
            },
        },
    }),
    headActions: css({
        display: 'flex',
        gap: '10px',
    }),
    businessCard: css({
        background: ' #FFFFFF',
        boxShadow: '0px 4px 10px -9px #EAF2FF',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
        boxSizing: 'border-box',
        maxWidth: '600px',
        width: '100%',
        transition: 'all .3s ease-in',
    }),
    topBox: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        justifyContent: 'space-between',
    }),
    bottomBox: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    stationDescription: css({
        fontWeight: 300,
        fontSize: '13px',
        marginBottom: '24px',
        padding: '0 5px',
        color: '#000000',
    }),
    leftSide: css({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    }),
    viewLess: css({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        justifyContent: 'center',
    }),
    viewLessText: css({
        color: '#000000',
        fontWeight: 600,
    }),
    viewLessArrow: css({
        transform: 'rotate(180deg)',
    }),
    businessCardLogo: css({
        background: '#0057B7',
        borderRadius: '5px',
        width: '40px',
        height: '48px',
        fontWeight: 900,
        fontSize: '16px',
        lineHeight: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#000000',
    }),
    businessCardInfo: css({
        color: '#000000',
        fontSize: '13px',
        fontWeight: 300,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '8px',
    }),
    businessCardInfoTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '15px',
    }),
    businessCardInfoDescription: css({
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '14px',
        lineHeight: '14px',
    }),
    distance: css({
        fontSize: '13px',
        fontWeight: 300,
        color: '#000000',
        marginTop: '4px',
    }),
    arrowBottom: css({
        width: '24px',
        height: '24px',
        transition: 'all 0.3s ease-in',
    }),
    arrowRight: css({
        width: '24px',
        height: '24px',
        transition: 'all 0.3s ease-in',
        transform: 'rotate(-90deg)',
    }),
    arrowTop: css({
        width: '24px',
        height: '24px',
        transition: 'all 0.3s ease-in',
        transform: 'rotate(-180deg)',
    }),
    buttonBox: css({
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        marginBottom: '20px',
    }),
    locationHeaderButton: css({
        color: '#ffffff',
        padding: '16px',
        fontWeight: 600,
        fontSize: '15px',
        lineHeight: '16px',
        borderRadius: '8px',
        cursor: 'pointer',
        gap: '8px',
        width: 'calc(50% - 4px)',
        textAlign: 'center',
        display: 'block',
    }),
    shareButton: css({
        backgroundColor: '#000000',
    }),
    directionButton: css({
        backgroundColor: '#004FC6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    }),
};

export default locationHeaderStyles;
